import React from "react";
import bidvCert from "../../assets/landing/img/certificate/Cong-van-BIDV-Fute.jpg";
import mbCert from "../../assets/landing/img/certificate/Cong-van-MB-Fute.jpg";

const certificates = [
  {
    src: bidvCert,
    alt: "Giấy chứng nhận BIDV",
    desc: "Công văn hợp tác giữa Ngân hàng TMCP Đầu tư và Phát triển Việt Nam và Công ty CP FUTE",
  },
  {
    src: mbCert,
    alt: "Giấy chứng nhận MB Bank",
    desc: "Công văn hợp tác giữa Ngân hàng TMCP Quân đội và Công ty CP FUTE",
  },
];

const OpenApiCertificates = () => (
  <div className="container text-center my-5">
    <h2 className="fw-bold mb-5">CHỨNG NHẬN HỢP TÁC VỚI NGÂN HÀNG</h2>
    <div className="row justify-content-center">
      {certificates.map((item, idx) => (
        <div className="col-md-5 mb-4" key={idx}>
          <div className="card border-0">
            <img
              src={item.src}
              className="img-fluid border border-4 border-warning rounded"
              alt={item.alt}
            />
          </div>
          <div className="mt-2">{item.desc}</div>
        </div>
      ))}
    </div>
  </div>
);

export default OpenApiCertificates;
